import LayoutContainer from './LayoutContainer';

export default LayoutContainer;
